export default "__VITE_ASSET__CNEX9y3B__"